import React from 'react';
import PanelReturnAlert from './PanelReturnAlert';
import PanelReturnTextBox from './PanelReturnTextBox';
import './index.css'; // Import the CSS file that will import all others

// Define the field data interface
interface FieldData {
  label: string;
  value: string;
}

interface ReturnPanelProps {
  // Fields array for displaying information
  fields: FieldData[];
  // Title for the panel (optional)
  title?: string;
  onClose: () => void;
}

const ReturnPanel: React.FC<ReturnPanelProps> = ({ fields, title = "WELCOME BACK", onClose }) => {
      
  return (
    <div className="return-panel-overlay">
      <div className="return-panel-content">
        {/* Logo/Alert component at the top */}
        <div className="return-panel-item">
          <PanelReturnAlert title={title} />
        </div>
        
        {/* Text box with fields in the middle */}
        <div className="return-panel-item">
          <PanelReturnTextBox fields={fields} />
        </div>
        
        {/* Close button at the bottom */}
        <div className="return-panel-item">          <button
            className="return-close-btn"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReturnPanel;
